import { render, staticRenderFns } from "./Nomina.vue?vue&type=template&id=1fd01530"
import script from "./Nomina.vue?vue&type=script&lang=js"
export * from "./Nomina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports